// extracted by mini-css-extract-plugin
module.exports = {"brandsCarousel":"BrandCarousel_brandsCarousel__GtqHc","brandsCarousel__item":"BrandCarousel_brandsCarousel__item__G5IXA"};